import { useState } from "react";

export const useDialogState = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [quantity, setQuantity] = useState("");
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const openDialog = (item: any) => {
    setSelectedItem(item);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setQuantity("");
    setSelectedItem(null);
  };

  return {
    isOpen,
    setIsOpen,
    quantity,
    setQuantity,
    selectedItem,
    setSelectedItem,
    openDialog,
    closeDialog,
  };
};